<template>
    <div class="form-group">

        <div class="container-square">
            <img :src="value"
                 :class="{'is-invalid-image':errors.has(name)}"
                 @click="$refs.fileInput.click()"
                 class="in-square img-thumbnail image-cropper-modal">
        
        </div>
          <span class="del" @click=" $emit('input', '')">حذف</span>
        <b-progress :value="percent" variant="info" :striped="true" class="my-2" v-if="percent<100"></b-progress>

        <input v-validate="rules"
               :value="value"
               @input="inputValue"
               :id="name"
               type="hidden"
               :name="name">

        <input type="file"
               ref="fileInput"
               :id="'file_'+name"
               @change="setImage"
               class="d-none"
               accept=".jpg,.jpeg,.png,.gif,.bmp,.tiff">

        <div v-if="errors.has(name)" class="invalid-image-feedback">
            {{errors.first(name)}}
        </div>

        <b-modal hide-footer hide-header @hidden="modalHidden"
                 ref="cropprrModal" size="lg">

            <div style="min-height: 80vh;">

                <vue-cropper ref='cropper'
                             :src=imgSrc
                             alt="Source Image"
                             :cropmove="cropImage"
                             :viewMode=1
                             :aspectRatio=aspectRatio
                             :autoCropArea=1
                ></vue-cropper>

            </div>

        </b-modal>


    </div>

</template>

<script>
import VueCropper from "vue-cropperjs";

export default {
  name: "FieldImage",
  computed: {
    aspectRatio() {
      if (!this.ratio) {
        return 1;
      }
      return this.ratio;
    }
  },
  inject: ["$validator"],
  components: {
    VueCropper
  },
  props: ["value", "name", "rules", "link", "ratio"],
  data: function() {
    return {
      percent: 100,
      imgSrc: "",
      cropImg: ""
    };
  },

  methods: {
    modalHidden() {
      var data = this.$refs.cropper.getCroppedCanvas().toDataURL("image/png");
      var this2 = this;
      this.axios
        .post(
          this.link,
          {
            image: data
          },
          {
            onUploadProgress: function(e) {
              this2.percent = parseInt((e.loaded / e.total) * 100);

              // Do whatever you want with the native progress event
            }
          }
        )
        .then(function({ data }) {
          console.log(data);
          this2.$emit("input", data.data.url);
        })
        .catch(function(error) {});
    },
    setImage(e) {
      this.$refs.cropprrModal.show();

      const file = e.target.files[0];

      if (!file.type.includes("image/")) {
        // alert('Please select an image file');
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      //this.value = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    rotate() {
      // guess what this does :)
      this.$refs.cropper.rotate(90);
    },
    inputValue(e) {
      this.$emit("input", e.target.value);
    }
  }
};
</script>
<style scoped>
.form-group {
  position: relative;
}

.del {
  position: absolute;
  top: 0px;
  padding: 10px;
  color: #ffffff;
  cursor: pointer;
  background: #dc354588;
  border-top-right-radius: 5px;
}
.del:hover {
  background: #dc3545;
}
.is-invalid-image {
  border-color: #dc3545;
}

.invalid-image-feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

.in-square {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
}

.container-square {
  position: relative;
  width: 100%;
  padding-top: 66.6%;
}
</style>




// WEBPACK FOOTER //
// src/components/fields/FieldImage.vue